import { render, staticRenderFns } from "./JISTWEBSSORDRCT.vue?vue&type=template&id=cd248bb4"
import script from "./JISTWEBSSORDRCTController.ts?vue&type=script&lang=ts&external"
export * from "./JISTWEBSSORDRCTController.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports